import {
  TableCellType,
  TableHeader,
} from "../components/custom-table/table";
import { MemberTableColumnKeys } from "../enums/tableColumnKeys";
import type { MemberTableData } from "../data-model/tablesData";
import type { MemberModel } from "./MembersPage";

export const MemberTableHeaderColumns: TableHeader[] = [
  {
    label: "Member",
    key: MemberTableColumnKeys.Name,
    sortable: true,
    order: 1,
    width: 40,
    type: TableCellType.STRING,
  },
  {
    label: "Mail",
    key: MemberTableColumnKeys.Email,
    sortable: true,
    order: 2,
    width: 39,
    type: TableCellType.STRING,
  },
  {
    label: "Role",
    key: MemberTableColumnKeys.Role,
    sortable: true,
    order: 3,
    width: 15,
    type: TableCellType.BADGE,
  },
  {
    label: "",
    key: MemberTableColumnKeys.Actions,
    sortable: false,
    order: 4,
    width: 6,
    type: TableCellType.EDIT_DELETE_ICONS,
  },
];

const getRoleBadgeConfig = (role: string) => {
  if (role === "Admin") {
    return {
      text: role,
      color: "#1D4ED8",
      bgColor: "#DBEAFE",
    };
  }
  return {
    text: role,
    color: "#374151",
    bgColor: "#F3F4F6",
  };
};

interface GenerateUIDataOptions {
  onEditMember?: (member: MemberModel) => void;
  onDeleteMember?: (member: MemberModel) => void;
}

export function generateUIDataForMemberTable(
  members: MemberModel[],
  options?: GenerateUIDataOptions,
): MemberTableData[] {
  return members.map((memberItem) => {
    const name: string = memberItem.name;
    const email: string = memberItem.email;
    const role: string = memberItem.roleId;
    const actionsData = {
      onEdit: () => {
        options?.onEditMember?.(memberItem);
      },
      onDelete: () => {
        options?.onDeleteMember?.(memberItem);
      },
    };

    return {
      [MemberTableColumnKeys.Name]: name,
      [MemberTableColumnKeys.Email]: email,
      [MemberTableColumnKeys.Role]: getRoleBadgeConfig(role),
      [MemberTableColumnKeys.Actions]: actionsData,
    };
  });
}
